import * as React from "react";
import {Box, Flex, Img, LinkBox, LinkOverlay} from "@chakra-ui/react";

export default function ChapterNav({chapters, lang}){
    function handleClick(event) {

        event.preventDefault();
        const href = event.currentTarget.getAttribute("href")
        document.querySelector(href).scrollIntoView({
            behavior: "smooth"
        })
    }
    const isTwoCols = (chapters && chapters.length > 3) ?? null

    return (
        <>
        {/*<Box mt={'3rem'}>*/}
        {/*    <Box as={'h3'} fontSize={'26px'} fontWeight={'bold'} mt={'0 !important'} pt={'0 !important'} mb={'2rem'}>Z tego artykułu dowiesz się:</Box>*/}
        {/*    <ol>*/}
        {/*        {chapters && chapters.map((chapter, index) => {*/}
        {/*            const chapterAnchor = chapter?.attribs?.id ?? null*/}
        {/*            const chapterQuestion = chapter?.attribs['data-question'] ?? null*/}
        {/*            const chapterImgUrl = chapter?.children[1]?.children[3]?.children[1]?.attribs?.src ?? null*/}
        {/*            const chapterImgAlt = chapter?.children[1]?.children[3]?.children[1]?.attribs?.alt ?? null*/}
        {/*            // console.log(chapter?.attribs['data-navigation'])*/}
        {/*            return(*/}
        {/*                <Box as={'li'} key={'chapter-question_'+ index}*/}
        {/*                     sx={{*/}
        {/*                         '&::marker' : {*/}
        {/*                             transition:'color .25s ease'*/}
        {/*                         }*/}
        {/*                     }}*/}
        {/*                     _hover={{*/}
        {/*                         '&::marker' : {*/}
        {/*                             color:'brand.lightBlue'*/}
        {/*                         }*/}
        {/*                     }}*/}
        {/*                >*/}
        {/*                    <Link onClick={handleClick} href={chapterAnchor} textDecoration={'none !important'}*/}
        {/*                    transition={'color .25s ease'}*/}
        {/*                    _hover={{*/}
        {/*                        color:'#828282',*/}
        {/*                        '&:marker' : {*/}
        {/*                            color:'brand.lightBlue'*/}
        {/*                        }*/}
        {/*                    }}*/}
        {/*                >{chapterQuestion}</Link></Box>*/}
        {/*            )*/}
        {/*        })*/}
        {/*        }*/}
        {/*    </ol>*/}
        {/*</Box>*/}
        <Box className={'chaptersNav'} bgColor={'#F9FAFC'} pos={'relative'} padding={'3rem 0'}  margin={'4rem 0 0'}
          _before={{
              content:'""',
              position:'absolute',
              left:'50%',
              top:'0',
              width:'200vw',
              height:'100%',
              transform:'translateX(-50%)',
              bgColor:'#F9FAFC',
              zIndex:'-1',
          }}
        >
        <Box as={'p'} fontSize={{base:'18px !important', lg:'21px !important',xl:'26px !important'}} fontWeight={'bold'} mt={'0 !important'} pt={'0 !important'}> {lang === 'EN' ? 'Table of contents' :'Spis treści'}</Box>
        <Flex gap={{base: '2rem',lg:'2rem',xl:'1rem',xxl:'2rem'}} flexWrap={'wrap'}>
            {chapters && chapters.map((chapter, index) => {
                const chapterAnchor = chapter?.attribs?.id ?? null
                const chapterTitle = chapter?.attribs['data-navigation'] ?? null
                const chapterImgUrl = chapter?.children[1]?.children[3]?.children[1]?.attribs?.src ? chapter?.children[1]?.children[3]?.children[1]?.attribs?.src : chapter?.children[1]?.children[3]?.children[1]?.children[2]?.attribs['data-src'] ?chapter?.children[1]?.children[3]?.children[1]?.children[2]?.attribs['data-src'] : null
                const chapterImgAlt = chapter?.children[1]?.children[3]?.children[1]?.children[2]?.attribs?.alt ?? null

                return(
                    <Box maxW={{base:'100%', lg:chapters && chapters.length > 3 ? '100%' : 'calc(33.333% - 1.35rem)', xl:chapters && chapters.length > 3 ? '100%' : 'calc(33.333% - .7rem)', xxl:chapters && chapters.length > 3 ? '100%' : 'calc(33.333% - 1.35rem)'}} key={'chapter-nav_'+ index} w={{base:'100%',lg:isTwoCols ? 'calc(50% - 1rem)' : 'auto'}}>
                        <LinkBox fontSize={'15px'} textDecoration={'none !important'} zIndex={2} display={'flex'} flexDirection={{base:'row', lg:isTwoCols ? 'row' :'column'}} gap={{base:'1.5rem', lg:isTwoCols ? '1.5rem' : '1rem'}}
                            _hover={{
                                '> img' : {
                                    transform:'scale(1.15)'
                                },
                                '.chapterTitle' : {
                                    opacity:'.6'
                                }
                            }}
                        >
                            {chapterImgUrl && <Box maxW={{base:'70px', mobile:'100px'}} height={'120px'}><Img src={chapterImgUrl} alt={chapterImgAlt} objectFit={'cover'} maxHeight={'120px !important'}transition={'transform .3s ease'}/></Box> }
                            <Box display={{base:'flex',lg:isTwoCols ? 'flex' : 'block'}} flexDirection={'column'} justifyContent={'center'}>
                                <Box color={'brand.lightBlue'} mb={'.5rem'} fontFamily={'Abril-Text'}>{lang === 'EN' ? 'Chapter' :'Rozdział'} {index + 1}</Box>
                                <LinkOverlay onClick={handleClick} className={'chapterTitle'} textDecoration={'none !important'} color={'black !important'} href={'#' + chapterAnchor} fontWeight={'600'} fontSize={isTwoCols ? '14px' : '15px'} lineHeight={isTwoCols > 3 ? '24px' : '25px'} transition={'opacity .3s ease !important'}>{chapterTitle}</LinkOverlay>
                            </Box>
                        </LinkBox>
                    </Box>
                )
            })
            }

        </Flex>
        </Box>
        </>
    )
}